import { Expose, Transform, Type } from "class-transformer";
import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";
import { UserDto } from "@/core/features/users/user.dto";
import { PlusDto } from "@/core/features/pluses/plus.dto";
import { toEuros } from "@/utils/numberUtils";

export class UserHasPlusDto extends BaseEntityDto {
  @Expose()
  userId: string;

  @Expose()
  plusId: string;

  @Expose()
  @Transform(({ value }) => toEuros(value))
  unitPrice: number;

  @Expose()
  @Type(() => UserDto)
  user?: UserDto;

  @Expose()
  @Type(() => PlusDto)
  plus?: PlusDto;
}
